import { URL_FILMS_DOCS } from 'services/url/constants'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { getFilterSetData } from 'services/filter-set/actions'
import {
  FILTER_SET_FILM,
  FILTER_SET_DEFAULT,
} from 'services/filter-set'
import {
  SET_USER_DATA_LANGUAGE,
} from 'services/user/actions'
import _get from 'lodash/get'
import { get as getConfig } from 'config'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'

const config = getConfig()

// TODO: implement for all classic facet pages, not just films & docs
function isFilteredPage ({ state }) {
  const { app, resolver } = state
  const { features } = config
  const filmFiltersEnabled = _get(features, ['filmFilters', 'enabled'])
  const isFilm = resolver.get('path').includes(URL_FILMS_DOCS)
  const nextBootstrapComplete = app.get('bootstrapComplete')
  return isFilm && filmFiltersEnabled && nextBootstrapComplete
}

function getFilterSetByLocation () {
  // TODO: Update when used on other pages
  return FILTER_SET_FILM
}

// eslint-disable-next-line import/prefer-default-export
export function getFilterSet ({ after }) {
  return after([SET_RESOLVER_DATA, SET_APP_BOOTSTRAP_PHASE], async ({ dispatch }) => {
    dispatch(getFilterSetData({ filterSet: getFilterSetByLocation() }))
    dispatch(getFilterSetData({ filterSet: FILTER_SET_DEFAULT }))
  })
    .when(isFilteredPage)
}

export function filterLanguageChange ({ after }) {
  return after([SET_USER_DATA_LANGUAGE, SET_APP_BOOTSTRAP_PHASE], async ({ dispatch }) => {
    dispatch(getFilterSetData({ filterSet: getFilterSetByLocation() }))
    dispatch(getFilterSetData({ filterSet: FILTER_SET_DEFAULT }))
  })
    .when(isFilteredPage)
}
